export default {
    methods: {
        // socket返回数据处理
        processSocketData(response) {
            const _this = this
            if (['complete', 'generating'].indexOf(response.type) > -1) {
                const data = response.data
                if (data == null || data[data.length - 1] == null) {
                    this.loading = false
                    this.$refs.typing && (this.$refs.typing.isFinish = true)
                    this.$refs.typing && this.$refs.typing.currentTextArr.push('服务器端错误')
                    return
                }
                let str = data[data.length - 1][1] || ''
                str = str.replaceAll('@@', '"')
                // 将中间的替换成换行符，以便打印
                str = str.replaceAll(/(\r|\\n|\n\n|\n)+/, ' </br>')
                this.receiveStr = str
                if (str.length > 0 ) {
                    this.$refs.typing && this.$refs.typing.currentTextArr.push(str)
                }
                if (response.type == 'complete') {
                    // 数据全部传输完毕，保存历史记录
                    this.loading = false
                    this.$refs.typing && (this.$refs.typing.isFinish = true)
                    this.$refs.typing && this.$refs.typing.currentTextArr.push('')
                    // TODO
                }
            } else if (response.type == 'error') {
                this.loading = false
                this.$refs.typing && (this.$refs.typing.isFinish = true)
                this.$refs.typing && this.$refs.typing.currentTextArr.push('服务器端错误')
                return
            }
        },
    },
}